import { Component, OnInit, Inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup } from '@angular/forms';
import { ILab } from '../../../models/labs/lab';
import { LabService } from '../../../services/lab-service';

/*
 * Delete Lab Dialog
 */
@Component({
    selector: 'app-delete-lab',
    templateUrl: 'delete-lab-dialog.html',
    styleUrls: ['./delete-lab-dialog.scss']
  })
  export class DialogDeleteLabComponent implements OnInit  {
    loading: boolean = false;
    processing: boolean = false;
    labDetailsId: number = 0;
    lab: ILab = null;

    labForm = new FormGroup({
    });
  
    constructor(public labService: LabService,
                private toastr: ToastrService, 
                @Inject(MAT_DIALOG_DATA) public data: number,
                private dialogRef: MatDialogRef<DialogDeleteLabComponent>) {
                  this.loading = true;
                  this.labDetailsId = this.data;
                  this.loadLab();
    }

    ngOnInit(): void {
      // ngOnInit    
    }

    loadLab() {
      this.loading = true;
      this.labService.getLab(this.labDetailsId).subscribe(
        result => {
          this.lab = result;
          this.loading = false;
        },
        error => {
          this.toastr.error("Unable to load Lab");
          this.loading = false;
          this.dialogRef.close();
        }
      );
    }

    onSubmit() {
      this.processing = true;
      this.labService.deleteLab(this.lab.id).subscribe(
        result => {
          this.processing = false;
          this.toastr.success("Lab was Deleted");
        },
        error => {
          this.processing = false;
          this.toastr.error("Lab was not Deleted");
        },
        () => {
          this.dialogRef.close();
        }
      );
    }
  }